import { useTranslation } from "react-i18next";
import { Panel } from 'primereact/panel';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { useState } from 'react';

export default function EnderecoHist({
  enderecos,
  isConsultaNova,
}: {
  enderecos: any;
  isConsultaNova?: boolean;
}) {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const [enderecoSelecionado, setEnderecoSelecionado] = useState<any>(null);

  const abrirMapa = (endereco: any) => {
    setEnderecoSelecionado(endereco);
    setVisible(true);
  };

  const montarEnderecoCompleto = (endereco: any) => {
    const partes = [
      endereco.logradouro,
      endereco.numero,
      endereco.complemento,
      endereco.bairro,
      endereco.cidade,
      endereco.uf,
      endereco.cep
    ].filter(Boolean);
    return partes.join(', ');
  };

  const footerContent = (
    <div>
      <Button label="Fechar" icon="pi pi-times" style={{ color: '#183462' }} onClick={() => setVisible(false)} className="p-button-text" />
    </div>
  );

  const acaoTemplate = (rowData: any) => {
    return (
      <Button
        icon="pi pi-map-marker"
        className="p-button-rounded p-button-info p-button-text"
        tooltip="Ver no Mapa"
        tooltipOptions={{ position: 'top' }}
        onClick={() => abrirMapa(rowData)}
      />
    );
  };

  const MapDialog = () => (
    <Dialog
      header="Localização no Mapa"
      visible={visible}
      style={{ width: '80vw', maxWidth: '900px' }}
      onHide={() => setVisible(false)}
      footer={footerContent}
    >
      {enderecoSelecionado && (
        <div>
          <p style={{ marginBottom: '1rem' }}>
            <strong>Endereço:</strong> {montarEnderecoCompleto(enderecoSelecionado)}
          </p>
          <iframe
            className="no-print"
            title="Mapa do Endereço"
            width="100%"
            height="400"
            style={{ border: 0, borderRadius: '8px' }}
            loading="lazy"
            allowFullScreen
            referrerPolicy="no-referrer-when-downgrade"
            src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyAmF0F41b3t1GX-sJ0rY0q1ZbyPnKENsB0&q=${encodeURIComponent(montarEnderecoCompleto(enderecoSelecionado))}`}
          />
          <img
            className="print-only"
            style={{ width: '100%', borderRadius: '8px', display: 'none' }}
            alt={`Mapa do endereço: ${montarEnderecoCompleto(enderecoSelecionado)}`}
            src={`https://maps.googleapis.com/maps/api/staticmap?center=${encodeURIComponent(montarEnderecoCompleto(enderecoSelecionado))}&zoom=15&size=600x400&markers=${encodeURIComponent(montarEnderecoCompleto(enderecoSelecionado))}&key=AIzaSyAmF0F41b3t1GX-sJ0rY0q1ZbyPnKENsB0`}
          />
        </div>
      )}
    </Dialog>
  );

  if (isConsultaNova) {
    return (
      <div
        style={{
          backgroundColor: '#FFFFFF',
          borderRadius: '16px',
          border: '1px solid #E5E7EB',
          boxShadow: '0 4px 20px -2px rgba(0,0,0,0.05)',
          padding: '24px',
        }}
      >
        {/* Header */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
          <div
            style={{
              backgroundColor: '#EFF6FF',
              borderRadius: '10px',
              padding: '10px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <i className="pi pi-map-marker" style={{ color: '#2563EB', fontSize: '18px' }}></i>
          </div>
          <div>
            <h3 style={{ fontSize: '1rem', fontWeight: 700, margin: 0, color: '#1E3A8A' }}>
              {t('historicoEndereco')}
            </h3>
            <span style={{ fontSize: 'small', color: '#6B7280' }}>
              {enderecos?.length || 0} endereço{enderecos?.length !== 1 ? 's' : ''} registrado{enderecos?.length !== 1 ? 's' : ''}
            </span>
          </div>
        </div>

        {/* Address list */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          {enderecos && enderecos.map((end: any, idx: number) => (
            <div
              key={idx}
              style={{
                display: 'flex',
                alignItems: 'flex-start',
                justifyContent: 'space-between',
                padding: '14px 16px',
                backgroundColor: idx === 0 ? '#F0F9FF' : '#F9FAFB',
                borderRadius: '12px',
                border: idx === 0 ? '1px solid #BAE6FD' : '1px solid #F3F4F6',
                gap: '12px',
                flexWrap: 'wrap',
              }}
            >
              <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-start', flex: 1 }}>
                <i
                  className="pi pi-map-marker"
                  style={{
                    color: idx === 0 ? '#0369A1' : '#9CA3AF',
                    fontSize: '16px',
                    marginTop: '2px',
                    flexShrink: 0,
                  }}
                />
                <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                    <span
                      style={{
                        fontWeight: idx === 0 ? 700 : 600,
                        color: idx === 0 ? '#1E40AF' : '#1F2937',
                        fontSize: 'small',
                      }}
                    >
                      {end.logradouro}{end.numero ? `, ${end.numero}` : ''}
                    </span>
                    {idx === 0 && (
                      <span
                        style={{
                          backgroundColor: '#DBEAFE',
                          color: '#1D4ED8',
                          fontSize: '0.7rem',
                          fontWeight: 700,
                          padding: '1px 6px',
                          borderRadius: '4px',
                        }}
                      >
                        ATUAL
                      </span>
                    )}
                  </div>
                  <span style={{ fontSize: '0.8rem', color: '#6B7280' }}>
                    {[end.bairro, end.cidade, end.uf].filter(Boolean).join(' · ')}
                    {end.cep ? ` · CEP ${end.cep}` : ''}
                  </span>
                  {end.complemento && (
                    <span style={{ fontSize: '0.75rem', color: '#9CA3AF' }}>{end.complemento}</span>
                  )}
                </div>
              </div>

              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexShrink: 0 }}>
                {end.data && (
                  <span
                    style={{
                      backgroundColor: '#F3F4F6',
                      color: '#6B7280',
                      fontSize: '0.75rem',
                      fontWeight: 600,
                      padding: '3px 8px',
                      borderRadius: '6px',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {end.data}
                  </span>
                )}
                <button
                  onClick={() => abrirMapa(end)}
                  style={{
                    background: 'none',
                    border: '1px solid #E5E7EB',
                    borderRadius: '8px',
                    padding: '5px 10px',
                    cursor: 'pointer',
                    color: '#6B7280',
                    fontSize: '0.75rem',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '4px',
                    transition: 'all 0.15s ease',
                  }}
                  onMouseEnter={e => {
                    (e.currentTarget as HTMLButtonElement).style.backgroundColor = '#EFF6FF';
                    (e.currentTarget as HTMLButtonElement).style.borderColor = '#BAE6FD';
                    (e.currentTarget as HTMLButtonElement).style.color = '#1D4ED8';
                  }}
                  onMouseLeave={e => {
                    (e.currentTarget as HTMLButtonElement).style.backgroundColor = 'transparent';
                    (e.currentTarget as HTMLButtonElement).style.borderColor = '#E5E7EB';
                    (e.currentTarget as HTMLButtonElement).style.color = '#6B7280';
                  }}
                >
                  <i className="pi pi-map" style={{ fontSize: '12px' }} />
                  Mapa
                </button>
              </div>
            </div>
          ))}
        </div>

        <MapDialog />
      </div>
    );
  }

  return (
    <Panel header={t('historicoEndereco')}>
      <DataTable size="small" value={enderecos} tableStyle={{ minWidth: '50rem' }}>
        <Column field="logradouro" header={t('logradouro')}></Column>
        <Column field="cep" header={t('cep')}></Column>
        <Column field="bairro" header={t('bairro')}></Column>
        <Column field="cidade" header={t('cidade')}></Column>
        <Column field="uf" header={t('uf')}></Column>
        <Column field="complemento" header={t('complemento')}></Column>
        <Column field="numero" header={t('numero')}></Column>
        <Column header={t('mapa')} body={acaoTemplate} style={{ width: '80px', textAlign: 'center' }}></Column>
      </DataTable>

      <Dialog
        header="Localização no Mapa"
        visible={visible}
        style={{ width: '80vw', maxWidth: '900px' }}
        onHide={() => setVisible(false)}
        footer={footerContent}
      >
        {enderecoSelecionado && (
          <div>
            <p style={{ marginBottom: '1rem' }}>
              <strong>Endereço:</strong> {montarEnderecoCompleto(enderecoSelecionado)}
            </p>
            <iframe
              className="no-print"
              title="Mapa do Endereço"
              width="100%"
              height="400"
              style={{ border: 0, borderRadius: '8px' }}
              loading="lazy"
              allowFullScreen
              referrerPolicy="no-referrer-when-downgrade"
              src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyAmF0F41b3t1GX-sJ0rY0q1ZbyPnKENsB0&q=${encodeURIComponent(montarEnderecoCompleto(enderecoSelecionado))}`}
            />
            <img
              className="print-only"
              style={{ width: '100%', borderRadius: '8px', display: 'none' }}
              alt={`Mapa do endereço: ${montarEnderecoCompleto(enderecoSelecionado)}`}
              src={`https://maps.googleapis.com/maps/api/staticmap?center=${encodeURIComponent(montarEnderecoCompleto(enderecoSelecionado))}&zoom=15&size=600x400&markers=${encodeURIComponent(montarEnderecoCompleto(enderecoSelecionado))}&key=AIzaSyAmF0F41b3t1GX-sJ0rY0q1ZbyPnKENsB0`}
            />
          </div>
        )}
      </Dialog>
    </Panel>
  );
}
